import * as React from 'react'
import { Grid, FormControlLabel, MenuItem, Radio } from '@material-ui/core'
import { Field, reduxForm, InjectedFormProps, change, formValueSelector } from 'redux-form'
import { TextField, RadioGroup } from 'redux-form-material-ui'
import autobind from 'autobind-decorator'
import { compose } from 'redux'
import {WithI18n, withI18n} from 'src/core/i18n/withI18n'
import {connect} from 'react-redux'
import {Select} from 'redux-form-material-ui'
import { Validator } from 'src/core/form/Validator'
import InputAutocomplete from 'src/shared/InputAutocomplete/InputAutocomplete'
import SelectWithField from 'src/shared/form/SelectWithField'
import { QuestionWpr } from 'src/shared/form/QuestionWpr'
import Alert from 'src/shared/Alert/Alert'
import { IAutocallRendement, periodicityCoupons } from 'src/type/cotation-form'
import CurrencyField from 'src/shared/form/CurrencyField'
import { parseNumber } from 'src/shared/utils/helpers'


const validate = values => Validator.buildWithCheckAll(values, {
    support_investissement: [Validator.required],
    nominal_cible: [Validator.required, Validator.positiveNumber],
    duree_du_placement: [Validator.required],
    periodicite_des_coupons: [Validator.required],
    sous_jacent: [Validator.required],
    seuil_autocall: [Validator.required, Validator.positiveNumber],
    coupon_conditionnel_minimum: [Validator.positiveNumber],
    coupon_conditionnel_maximum: [Validator.required, Validator.positiveNumber],
    coupon_garanti: [Validator.positiveNumber],
    barriere_de_coupon_conditionnel_minimum: [Validator.positiveNumber],
    barriere_de_protection_du_capital: [Validator.required, Validator.positiveNumber],
    nombre_de_periodes_avec_un_coupon_garanti: [Validator.numberBetween(0,30), Validator.positiveNumber]
}, checkAll);

const checkAll = (values, dispatch) => {
    if(
        (values.seuilAutocall && values.barriereCoupon && values.seuilAutocall <= values.barriereCoupon) ||
        (values.barriereCoupon && values.barriereProtectionCapital && values.barriereCoupon < values.barriereProtectionCapital) ||
        (values.seuilAutocall && values.barriereProtectionCapital && values.seuilAutocall < values.barriereProtectionCapital) ||
        (values.couponConditionnelMax && values.couponConditionnelMin && values.couponConditionnelMax < values.couponConditionnelMin) ||
        (values.nombreDePeriodesCoupon !== undefined && values.dureePlacement !== undefined && values.periodicite !== undefined && values.nombreDePeriodesCoupon > generateValuePeriodicite(values.dureePlacement, values.periodicite)) ||
        (values.couponGaranti && values.couponConditionnelMax && values.couponGaranti < values.couponConditionnelMax)
    ){
        return "form error"
    } else {
        return undefined
    }
}   

const generateValuePeriodicite = (dureePlacement, periodicite) =>{
    if(dureePlacement && periodicite){
        switch(periodicite){
            case 'Annuelle':
                return dureePlacement*1;
            case 'Semestrielle':
                return dureePlacement*2;
            case 'Trimestrielle':
                return dureePlacement*4;
            case 'Bimestrielle':
                return dureePlacement*6;
            case 'Mensuelle':
                return dureePlacement*12;
            case 'In-fine':
                return 1;
            default:
                return 0;
        }
    } else {
        return 0
    }
}


interface IProps extends WithI18n,
  ReturnType<typeof state2props>,
  ReturnType<typeof dispatch2props> {
  onSubmit: (values: any) => void;
}

const nominalTarget = () => {
    return Array.from(new Array(99), (val,index) => ({label : `${index+1} ${index+1 === 1 ? 'an' : 'ans'}`}))
}
const sousJacent = [
    "Eurostoxx 50 (SX5E Index)",
    "CAC 40 (CAC Index)",
    "CAC Large 60 Equal Weight excess return (CLEWE Index)",
    "S&P500 (SPX Index)",
    "Nikkei 225 (NKY Index)",
    "S&P Euro 50 Equal Weight Synthetic 5% Price Index (SPEU50ES Index)",
    "iSTOXX 70 Equal Weight Decrement 5% Eur Price (ISX70D5 Index)",
    "iSTOXX 50 Equal Weight Decrement 5% Eur Price (ISXE50E5 Index)",
    "iSTOXX France Germany Benelux 60 Equal Weight NR Decrement 5% (ISXE6EWND)"
]

class AutocallRendementForm extends React.Component<IProps & InjectedFormProps<IAutocallRendement>, {}> {

    render(){
        
        const {
            dureePlacement, nombreDePeriodesCoupon, barriereCoupon, seuilAutocall, periodicite,
            barriereProtectionCapital, couponGaranti, couponConditionnelMin, couponConditionnelMax,
            onSubmit  
        } = this.props

        return(
            <form onSubmit={onSubmit}>
                <Grid container>
                    <Grid item xs={12}>

                        <QuestionWpr
                            label="Support d'investissement"
                            isCheckBox={true}
                            isRequired={true}
                        >
                            <Field
                                name="support_investissement"
                                component={RadioGroup}
                            >
                                <FormControlLabel
                                    value="Dépôt à Terme"
                                    control={<Radio color="primary" />}
                                    label="Dépôt à Terme"
                                />
                                <FormControlLabel
                                    value="NEU MTN"
                                    control={<Radio color="primary" />}
                                    label="NEU MTN"
                                />
                                <FormControlLabel
                                    value="EMTN"
                                    control={<Radio color="primary" />}
                                    label="EMTN"
                                />
                            </Field>
                        </QuestionWpr>

                        <QuestionWpr
                            label="Nominal cible (€)"
                            isRequired={true}
                        >
                            <Field
                                name="nominal_cible"
                                component={CurrencyField}
                                fullWidth={true}
                            />
                        </QuestionWpr>

                        <QuestionWpr
                            label="Durée du placement"
                            isRequired={true}
                        >
                            <InputAutocomplete
                                data={nominalTarget()}
                                onSelect={this.onSelectNominalTarget}
                                placeholder=""
                            />
                            <Field name="duree_du_placement" component={TextField} type="hidden" 
                                style={{display: 'none'}}
                            />
                        </QuestionWpr>

                        <QuestionWpr
                            label="Périodicité des coupons"
                            isRequired={true}
                        >
                            <Field
                                name="periodicite_des_coupons"
                                component={Select}
                                fullWidth={true}
                            >
                                {this.renderSelectItemByArr(periodicityCoupons)}
                            </Field>
                        </QuestionWpr>

                        <QuestionWpr
                            label="Sous-jacent"
                            isRequired={true}
                        >
                            <Field
                                name="sous_jacent"
                                component={SelectWithField}
                                arrOptions={sousJacent}
                                otherOptionPlaceHolder={"Saisissez votre sous-jacent…"}
                                fullWidth={true}
                            />
                        </QuestionWpr>

                        <QuestionWpr
                            label="Seuil d’autocall (en % du niveau initial du sous-jacent)"
                            description="Performance du sous-jacent déclenchant le mécanisme de remboursement automatique anticipé et le versement du coupon cible"
                            isRequired={true}
                        >
                            <Field
                                name="seuil_autocall"
                                component={TextField}
                                type="number"
                                fullWidth={true}
                            />
                        </QuestionWpr>

                        <QuestionWpr
                            label="Coupon conditionnel maximum"
                            description="Coupon conditionnel maximum espéré"
                            isRequired={true}
                        >
                            <Field
                                name="coupon_conditionnel_maximum"
                                component={TextField}
                                type="number"
                                fullWidth={true}
                            />
                        </QuestionWpr>

                        <QuestionWpr
                            label="Coupon conditionnel minimum"
                            description="Coupon conditionnel minimum accepté"
                        >
                            <Field
                                name="coupon_conditionnel_minimum"
                                component={TextField}
                                type="number"
                                fullWidth={true}
                            />
                        </QuestionWpr>

                        <QuestionWpr
                            label="Barrière de coupon conditionnel minimum (en % du niveau initial du sous-jacent)"
                            description="Performance du sous-jacent déclenchant le versement d’un coupon minimum"
                        >
                            <Field
                                name="barriere_de_coupon_conditionnel_minimum"
                                component={TextField}
                                type="number"
                                fullWidth={true}
                            />
                        </QuestionWpr>

                        <QuestionWpr
                            label="Barrière de protection du capital (en % du niveau initial du sous-jacent)"
                            description="Barrière de protection du capital investi, niveau de baisse du sous-jacent entraînant la perte en capital"
                            isRequired={true}
                        >
                            <Field
                                name="barriere_de_protection_du_capital"
                                type="number"
                                component={TextField}
                                fullWidth={true}
                            />
                        </QuestionWpr>

                        <QuestionWpr
                            label="Nombre de périodes avec un coupon garanti"
                        >
                            <Field
                                name="nombre_de_periodes_avec_un_coupon_garanti"
                                component={TextField}
                                type="number"
                                fullWidth={true}
                            />
                        </QuestionWpr>

                        <QuestionWpr
                            label="Coupon garanti"
                            disabled={nombreDePeriodesCoupon<=0}
                        >
                            <Field
                                name="coupon_garanti"
                                component={TextField}
                                type="number"
                                fullWidth={true}
                                disabled={nombreDePeriodesCoupon<=0}
                            />
                        </QuestionWpr>

                        <QuestionWpr
                            label="Commentaire"
                        >
                            <Field
                                name="commentaire"
                                component={TextField}
                                fullWidth={true}
                            />
                        </QuestionWpr>
                        
                    </Grid>
                    {(
                        (seuilAutocall !== undefined && barriereCoupon !== undefined &&  seuilAutocall < barriereCoupon) ||
                        (barriereCoupon !== undefined && barriereProtectionCapital !== undefined && barriereCoupon < barriereProtectionCapital) ||
                        (seuilAutocall !== undefined && barriereProtectionCapital !== undefined && seuilAutocall < barriereProtectionCapital) ||
                        (couponConditionnelMax !== undefined && couponConditionnelMin !== undefined && couponConditionnelMax < couponConditionnelMin) ||
                        (nombreDePeriodesCoupon !== undefined && dureePlacement !== undefined && periodicite !== undefined && nombreDePeriodesCoupon > generateValuePeriodicite(dureePlacement,periodicite) ||
                        (couponGaranti !== undefined && couponConditionnelMax !== undefined && couponConditionnelMax <= couponGaranti))
                    ) &&
                        <Grid item xs={12}>
                            <Alert type="error">
                                {seuilAutocall !== undefined && barriereCoupon !== undefined && seuilAutocall < barriereCoupon &&
                                    <p>Le seuil d'autocall doit être supérieur à la barrière de coupon conditionnel minimum.</p>
                                }
                                {barriereCoupon !== undefined && barriereProtectionCapital !== undefined && barriereCoupon < barriereProtectionCapital &&
                                    <p>La barrière de coupon conditionnel doit être supérieur à la barrière de protection du capital.</p>
                                }
                                {seuilAutocall !== undefined && barriereProtectionCapital !== undefined && seuilAutocall < barriereProtectionCapital &&
                                    <p>Le seuil d'autocall doit être supérieur ou égal à la barrière de protection du capital.</p>
                                }
                                {couponConditionnelMax !== undefined && couponConditionnelMin !== undefined && couponConditionnelMax < couponConditionnelMin &&
                                    <p>Le coupon conditionnel maximum doit être supérieur au coupon conditionnel minimum.</p>
                                }
                                {nombreDePeriodesCoupon !== undefined && dureePlacement !== undefined && periodicite !== undefined &&  
                                    <>
                                        {nombreDePeriodesCoupon > generateValuePeriodicite(dureePlacement,periodicite) &&
                                            <p>La durée du placement modulo la périodicité doit être supérieur àu nombre de périodes avec un coupon garanti.</p>
                                        }
                                    </>
                                }
                                {couponGaranti !== undefined && couponConditionnelMax !== undefined &&  couponConditionnelMax <= couponGaranti &&
                                    <p>Le coupon conditionnel maximum doit être supérieur au coupon garanti .</p>
                                }
                            </Alert>

                            
                        </Grid>
                    }
                </Grid>
            </form>
        )
    }

    componentDidMount(){
        if(!this.props.initialValues){
            this.props.setValue("seuil_autocall", 100)
            this.props.setValue("nombre_de_periodes_avec_un_coupon_garanti", 0)
            this.props.setValue("barriere_de_protection_du_capital", 0)
        }
    }

    @autobind
    private onSelectNominalTarget(value){
        if(value){
            this.props.setValue("duree_du_placement", parseInt(value.label.match(/[0-9]+/g), 10));
        }
    }
    @autobind
    private renderSelectItemByArr(arr: any[]){
        return arr.map(a => (
            <MenuItem key={a} value={a}>{a}</MenuItem>
        ))
    }
}

const formName = 'AUTOCALL_RENDEMENT_form';

const state2props = (state, props) => ({
    periodicite: formValueSelector(formName)(state, 'periodicite_des_coupons'),
    dureePlacement: formValueSelector(formName)(state, 'duree_du_placement'),
    nombreDePeriodesCoupon: parseNumber("float", formValueSelector(formName)(state, 'nombre_de_periodes_avec_un_coupon_garanti')),
    barriereCoupon: parseNumber("float", formValueSelector(formName)(state, 'barriere_de_coupon_conditionnel_minimum')),
    seuilAutocall: parseNumber("float", formValueSelector(formName)(state, 'seuil_autocall')),
    barriereProtectionCapital: parseNumber("float", formValueSelector(formName)(state, 'barriere_de_protection_du_capital')),
    couponGaranti: parseNumber("int", formValueSelector(formName)(state, 'coupon_garanti')),
    couponConditionnelMin: parseNumber("float", formValueSelector(formName)(state, 'coupon_conditionnel_minimum')),
    couponConditionnelMax: parseNumber("float", formValueSelector(formName)(state, 'coupon_conditionnel_maximum')),
});

const dispatch2props = (dispatch: any) => ({
    setValue: (field, value) => dispatch(change(formName, field, value)),
});
  
export default compose(
    withI18n,
    connect(state2props, dispatch2props)
)(reduxForm<IAutocallRendement, IProps>({
    form: formName,
    validate
})(AutocallRendementForm))



// WEBPACK FOOTER //
// ./src/shared/Cotation/form/AutocallRendementForm.tsx